import { callApi } from "./api.service";

export const GetCharities = async (data: any) => {
  const endpoints = "/api/public/get-charites";
  return await callApi(endpoints, "POST", false,undefined, data);
};

export const SaveCharityPreferences = async (
  Data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoints = "/api/user/charity/save-preferences";
  return await callApi(endpoints, "POST", true, getToken, Data);
};
